<section class="content-header">
  <div #homePanel class="container-fluid home-panel">
    <div class="card home-container">
      <div class="card-body row">
        <div #homeDataPanel class="home-data-panel custom-scrollbar">
          <!-- No devices -->
          @if (devicesTotal === 0) {
            <div class="home-no-devices">
              @if (devices && devicesTotal == 0) {
                <div class="card-body">
                  <i class="fas fa-info-circle"></i>
                  <h3>
                    {{ "without-devices" | translate }}
                  </h3>
                </div>
              }
              @if (devicesTotal == null) {
                <div class="card-body">
                  <i class="fas fa-spinner fa-pulse"></i>
                </div>
              }
            </div>
          }

          <!-- Devices -->
          <div
            class="home-devices-panel"
            [ngClass]="{
              'home-devices-panel-reverse':
                sessionProfile != PROFILES.ARSON && sessionProfile != PROFILES.USUARIO_ARSON
            }"
          >
            @if (devices?.length > 0 || gateways?.length > 0) {
              <div class="home-data-row home-graphs-data">
                <div class="home-data-container">
                  <!-- Totals chart -->
                  @if (devicesTotal > 0) {
                    <div class="home-total-graph-container">
                      <div class="home-cards-title">
                        {{ "global" | translate }}
                      </div>
                      <div class="home-total-graph home-data-odd-row">
                        <div class="home-graph-title">
                          {{ "total" | translate }}
                          <span>
                            {{ formatNumber(devicesTotal, numberFormat) }}
                          </span>
                        </div>
                        <div class="home-graph-chart-container">
                          @if (!totalInNetwork && !totalNoCommunication && !totalPending) {
                            <div class="home-no-network">
                              {{
                                (devicesCountByType.walkBy.total
                                  ? "no-network-deployed"
                                  : "no-network-communication"
                                ) | translate
                              }}
                            </div>
                          }
                          @if (totalInNetwork || totalNoCommunication || totalPending) {
                            <div class="home-graph-chart" no-network-communication>
                              @if (deviceTotalsHighchartsOptions) {
                                <app-graph-controller
                                  [highchartsOptions]="deviceTotalsHighchartsOptions"
                                  [noOptionsParse]="true"
                                  [onlyGraph]="true"
                                  [disableShowPoints]="true"
                                  [data]="deviceTotalsChartOptions"
                                  (chartObject)="globalChartObject = $event"
                                ></app-graph-controller>
                              }
                            </div>
                          }
                          <div class="home-total-graph-legend">
                            <!-- In network -->
                            @if (totalInNetwork > 0) {
                              <div
                                class="home-graph-data-label pointer"
                                [ngStyle]="{
                                  opacity: totalGraphHiddenSeries?.includes('in-network')
                                    ? '0.5'
                                    : '1'
                                }"
                                [routerLink]="['/dispositivos/listado/asignados']"
                                [state]="{ data: ['ACTIVE'].concat(ALL_EXCEPT_CONCENTRATORS) }"
                                (mouseover)="
                                  highlightLinkedSeries('in-network');
                                  highlightLinkedGlobalSeries('in-network')
                                "
                                (mouseout)="
                                  totalGraphHiddenSeries = null;
                                  highlightLinkedSeries();
                                  highlightLinkedGlobalSeries()
                                "
                              >
                                {{ "in-network" | translate }}
                                <span class="home-graph-total-percent">
                                  {{
                                    formatNumber(
                                      (
                                        (totalInNetwork /
                                          (devicesTotal -
                                            devicesCountByType.externalWithoutCom.noCom -
                                            devicesCountByType.walkBy.total)) *
                                        100
                                      ).toFixed(2),
                                      numberFormat
                                    )
                                  }}%
                                </span>
                                <span class="home-graph-total greenIcon">
                                  {{ formatNumber(totalInNetwork, numberFormat) }}
                                </span>
                              </div>
                            }
                            <!-- No communication -->
                            @if (totalNoCommunication > 0) {
                              <div
                                class="home-graph-data-label pointer"
                                [ngStyle]="{
                                  opacity: totalGraphHiddenSeries?.includes('no-communication')
                                    ? '0.5'
                                    : '1'
                                }"
                                [routerLink]="['/dispositivos/listado/sin-comunicacion']"
                                [state]="{ data: ALL_EXCEPT_CONCENTRATORS }"
                                (mouseover)="
                                  highlightLinkedSeries('no-communication');
                                  highlightLinkedGlobalSeries('no-communication')
                                "
                                (mouseout)="
                                  totalGraphHiddenSeries = null;
                                  highlightLinkedSeries();
                                  highlightLinkedGlobalSeries()
                                "
                              >
                                {{ "no-communicates" | translate }}
                                <span class="home-graph-total-percent">
                                  {{
                                    formatNumber(
                                      (
                                        (totalNoCommunication /
                                          (devicesTotal -
                                            devicesCountByType.externalWithoutCom.noCom -
                                            devicesCountByType.walkBy.total)) *
                                        100
                                      ).toFixed(2),
                                      numberFormat
                                    )
                                  }}%
                                </span>
                                <span class="home-graph-total grayDarkIcon">
                                  {{ formatNumber(totalNoCommunication, numberFormat) }}
                                </span>
                              </div>
                            }
                            <!-- Pending -->
                            @if (totalPending > 0) {
                              <div
                                class="home-graph-data-label pointer"
                                [ngStyle]="{
                                  opacity: totalGraphHiddenSeries?.includes('pending') ? '0.5' : '1'
                                }"
                                [routerLink]="['/dispositivos/listado/no-asignados']"
                                [state]="{ data: ['ACTIVE'].concat(ALL_EXCEPT_CONCENTRATORS) }"
                                (mouseover)="
                                  highlightLinkedSeries('pending');
                                  highlightLinkedGlobalSeries('pending')
                                "
                                (mouseout)="
                                  totalGraphHiddenSeries = null;
                                  highlightLinkedSeries();
                                  highlightLinkedGlobalSeries()
                                "
                              >
                                {{ "pending" | translate }}
                                <span class="home-graph-total-percent">
                                  {{
                                    formatNumber(
                                      (
                                        (totalPending /
                                          (devicesTotal -
                                            devicesCountByType.externalWithoutCom.noCom -
                                            devicesCountByType.walkBy.total)) *
                                        100
                                      ).toFixed(2),
                                      numberFormat
                                    )
                                  }}%
                                </span>
                                <span class="home-graph-total purpleIcon">
                                  {{ formatNumber(totalPending, numberFormat) }}
                                </span>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <!-- KPIs -->
                  @if (devicesTotal > 0) {
                    <div class="home-kpis-panel">
                      <div
                        class="home-cards-title pointer"
                        [ngClass]="{
                          pointer:
                            sessionProfile == PROFILES.ARSON ||
                            sessionProfile == PROFILES.USUARIO_ARSON ||
                            sessionProfile == PROFILES.ADMIN_CLIENTE ||
                            sessionProfile == PROFILES.ADMIN_ENTIDAD
                        }"
                        (click)="
                          sessionProfile == PROFILES.ARSON ||
                          sessionProfile == PROFILES.USUARIO_ARSON ||
                          sessionProfile == PROFILES.ADMIN_CLIENTE ||
                          sessionProfile == PROFILES.ADMIN_ENTIDAD
                            ? goToKpis()
                            : null
                        "
                      >
                        KPIs
                        @if (
                          sessionProfile == PROFILES.ARSON ||
                          sessionProfile == PROFILES.USUARIO_ARSON ||
                          sessionProfile == PROFILES.ADMIN_CLIENTE ||
                          sessionProfile == PROFILES.ADMIN_ENTIDAD
                        ) {
                          <i class="fas fa-link"></i>
                        }
                      </div>
                      <div class="home-kpis-data-container">
                        <!-- Average last 5 days -->
                        <div class="home-kpis-readings">
                          <span class="home-kpis-value">
                            <i class="fa fa-tachometer-alt"></i>
                            {{ KpisCardsData?.lastFiveDaysAverage }}%
                          </span>
                          <span>
                            <span class="home-kpis-readings-separator">(</span>
                            {{ KpisCardsData?.metersReadedLastFiveDays }}
                            <span class="home-kpis-readings-separator">/</span>
                            {{ KpisCardsData?.totalMetersLastFiveDays }}
                            <span class="home-kpis-readings-separator">)</span>
                          </span>
                          <span class="home-alarms-title">{{ "meters" | translate }}</span>
                          <span>
                            <i class="fa fa-calendar-week"></i>
                            {{ "last-five-days" | translate }}
                          </span>
                        </div>
                        <!-- Average last day -->
                        <div class="home-kpis-readings">
                          <span class="home-kpis-value">
                            <i class="fa fa-tachometer-alt"></i>
                            {{ KpisCardsData?.lastDayAverage }}%
                          </span>
                          <span>
                            <span class="home-kpis-readings-separator">(</span>
                            {{ KpisCardsData?.metersReadedLastDay }}
                            <span class="home-kpis-readings-separator">/</span>
                            {{ KpisCardsData?.totalMetersLastDay }}
                            <span class="home-kpis-readings-separator">)</span>
                          </span>
                          <span class="home-alarms-title">{{ "meters" | translate }}</span>
                          <span>
                            <i class="fa fa-calendar-day"></i>
                            {{ "kpis-day" | translate }}
                          </span>
                        </div>
                        <!-- Readings -->
                        <div class="home-kpis-readings">
                          <span class="home-kpis-value">
                            <i class="fa fa-database"></i>
                            {{ KpisCardsData?.readingsLastDayAverage }}%
                          </span>
                          <span>
                            <span class="home-kpis-readings-separator">(</span>
                            {{ KpisCardsData?.readingsLastDay }}
                            <span class="home-kpis-readings-separator">/</span>
                            {{ KpisCardsData?.totalReadingsLastDayExpected }}
                            <span class="home-kpis-readings-separator">)</span>
                          </span>
                          <span class="home-alarms-title">{{ "readings" | translate }}</span>
                          <span>
                            <i class="fa fa-calendar-day"></i>
                            {{ KpisCardsData?.timestampParsed }}
                          </span>
                        </div>
                        <div class="home-kpis-advise">
                          {{ "kpis-data-advise" | translate }}
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Charts by device type -->
                  @if (networkChartOptions?.length > 0 || devicesChartOptions?.length > 0) {
                    <div class="home-graphs">
                      <!-- Network -->
                      @if (networkChartOptions?.length > 0) {
                        <div class="home-network-graphs">
                          <div class="home-cards-title">
                            {{ "network" | translate }}
                          </div>
                          <div class="home-device-graphs-container home-data-odd-row">
                            @for (device of networkChartOptions; track device; let i = $index) {
                              <div class="home-device-graph">
                                @if (networkHighchartsOptions) {
                                  <app-graph-controller
                                    [highchartsOptions]="networkHighchartsOptions"
                                    [noOptionsParse]="true"
                                    [onlyGraph]="true"
                                    [disableShowPoints]="true"
                                    [data]="networkChartOptions[i]"
                                    (chartObject)="networkChartObjects[i] = $event"
                                  ></app-graph-controller>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      }
                      <!-- Devices -->
                      @if (devicesChartOptions?.length > 0) {
                        <div class="home-devices-graphs">
                          <div class="home-cards-title">
                            {{ "devices" | translate }}
                          </div>
                          <div
                            class="home-device-graphs-container home-device-graphs-container-min-height"
                          >
                            @for (device of devicesChartOptions; track device; let i = $index) {
                              <div class="home-device-graph">
                                @if (deviceTypeHighchartsOptions) {
                                  <app-graph-controller
                                    [highchartsOptions]="deviceTypeHighchartsOptions"
                                    [noOptionsParse]="true"
                                    [onlyGraph]="true"
                                    [disableShowPoints]="true"
                                    [data]="devicesChartOptions[i]"
                                    (chartObject)="devicesChartObjects[i] = $event"
                                  ></app-graph-controller>
                                }
                              </div>
                            }
                            <!-- Legend -->
                            <div class="home-graph-legend">
                              <div>
                                <span>
                                  <i class="fas fa-mouse mouse-left-click"></i>
                                  :
                                </span>
                                <span>
                                  {{ "show-table" | translate }}
                                </span>
                              </div>
                              <div>
                                <span>
                                  ALT +
                                  <i class="fas fa-mouse mouse-left-click"></i>
                                  :
                                </span>
                                <span>
                                  {{ "map-layer-isolate" | translate }}
                                </span>
                              </div>
                              <div>
                                <span>
                                  CTRL +
                                  <i class="fas fa-mouse mouse-left-click"></i>
                                  :
                                </span>
                                <span>
                                  {{ "map-layer-add-remove" | translate }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          <div
            class="home-client-panel"
            [ngClass]="{
              'home-client-panel-reverse':
                sessionProfile != PROFILES.ARSON && sessionProfile != PROFILES.USUARIO_ARSON
            }"
          >
            <!-- Alarm data -->
            <div class="home-alarms-panel">
              @if (devicesTotal > 0) {
                <div class="home-data-row">
                  <div
                    class="home-cards-title pointer"
                    [routerLink]="['/alarmas/agrupacion/listado']"
                  >
                    {{ "alarms" | translate }}
                    <i class="fas fa-link"></i>
                  </div>
                  <div class="home-alarms-container home-data-odd-row">
                    <div
                      class="home-alarms"
                      [ngClass]="{
                        'home-alarms-full-width': !alarmCodeList || alarmCodeList?.length == 0
                      }"
                    >
                      <!-- Pictorial alarms chart -->
                      <app-graph-controller
                        class="home-alarms-graph"
                        [highchartsOptions]="alarmsHighchartsOptions"
                        [noOptionsParse]="true"
                        [onlyGraph]="true"
                        [disableShowPoints]="true"
                        [data]="alarmsChartOptions"
                      ></app-graph-controller>
                      <div class="home-alarms-data">
                        <div
                          class="pointer"
                          [routerLink]="['/alarmas/agrupacion/listado']"
                          [state]="{ dateRange: 'full', showInactives: false }"
                        >
                          <span class="home-alarms-value">
                            <i class="fas fa-link"></i>
                            {{ formatNumber(currentAlarms, numberFormat) }}
                            <i class="fa fa-tachometer-alt"></i>
                          </span>
                          <span class="home-alarms-title">{{ "active-alarms" | translate }}</span>
                        </div>
                        <div
                          class="pointer"
                          [routerLink]="['/alarmas/agrupacion/listado']"
                          [state]="{ dateRange: 'fiveDays', showInactives: true }"
                        >
                          <span class="home-alarms-value">
                            <i class="fas fa-link"></i>
                            {{ formatNumber(last5DaysAlarms, numberFormat) }}
                            <i class="fa fa-exclamation-triangle"></i>
                          </span>
                          <span class="home-alarms-title">{{ "last-five-days" | translate }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- Alarms cloud chart -->
                    @if (alarmCodeList?.length > 0) {
                      <div class="home-alarms-cloud-graph">
                        <app-graph-controller
                          [highchartsOptions]="alarmsCloudHighchartsOptions"
                          [noOptionsParse]="true"
                          [onlyGraph]="true"
                          [disableShowPoints]="true"
                          [data]="alarmsCloudChartOptions"
                        ></app-graph-controller>
                        <!-- Legend -->
                        <div class="home-graph-legend">
                          <div>
                            <span>
                              <i class="fas fa-mouse mouse-left-click"></i>
                              :
                            </span>
                            <span>
                              {{ "show-table" | translate }}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>

            <!-- Consumption -->
            <div class="home-consumptions-panel">
              @if (devicesTotal > 0) {
                <div class="home-data-row home-consumption-data">
                  <div class="home-cards-title">
                    {{ "consumption" | translate }}
                  </div>
                  <div
                    class="home-consumptions-container"
                    [ngClass]="{
                      'home-container-without-border':
                        sessionProfile === PROFILES.ARSON ||
                        sessionProfile === PROFILES.USUARIO_ARSON
                    }"
                  >
                    <!-- Consumption -->
                    <div class="home-consumptions">
                      <div>
                        <span class="home-consumptions-data">
                          {{ lastMonthConsumption?.valueParsed }}
                        </span>
                        <span class="home-consumptions-title">
                          {{ "last-month" | translate }}
                        </span>
                        <span>
                          <i class="fa fa-calendar-alt"></i>
                          {{ lastMonthConsumption?.date }}
                        </span>
                      </div>
                      <div>
                        <span class="home-consumptions-data">
                          {{ lastDayConsumption?.valueParsed }}
                        </span>
                        <span class="home-consumptions-title">{{ "kpis-day" | translate }}</span>
                        <span>
                          <i class="fa fa-calendar-day"></i>
                          {{ lastDayConsumption?.date }}
                        </span>
                      </div>
                    </div>
                    <div class="home-consumptions-graph">
                      <!-- Chart -->
                      @if (!avoidConsumptionLoad) {
                        <app-graph-controller
                          [highchartsOptions]="consumptionHighchartsOptions"
                          [data]="consumptionChartOptions"
                          [onlyGraph]="true"
                        ></app-graph-controller>
                      }
                    </div>
                    @if (sessionProfile == PROFILES.ARSON) {
                      <div class="home-consumption-redo">
                        <button
                          mat-button
                          class="mat-button-icon-text"
                          (click)="recalculateConsumption()"
                          [title]="'recalculate-data' | translate"
                        >
                          <i class="fa-solid fa-calculator"></i>
                          {{ "recalculate-data" | translate }}
                        </button>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Meters map -->
        <div class="home-map-panel">
          <div class="home-map-container" #mapContainer>
            @if (mapHeight) {
              <app-map-controller
                [mapHeight]="mapHeight"
                [filter]="mapFilter"
                [deviceModelsFilter]="deviceModelsFilter"
                [map3d]="true"
                [mapType]="mapType"
                [drawAgrupationOutline]="drawAgrupationOutline"
                [freeDrawEnabled]="true"
                [allowKml]="true"
                [exportKml]="true"
                [mapSearch]="mapSearch"
                [allowSaveData]="true"
                (selectedDevices)="HomeService.goToTable($event, gateways)"
                (activate3dMapFlag)="activate3dMap()"
                [newActiveLayers]="mapActiveLayers"
                [locationsData]="gatewayLocations"
                [gatewaysData]="gateways"
                [metersData]="devices"
              ></app-map-controller>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
